import { Fragment, type PropsWithChildren } from "react";
import { FullScreenModal } from "@/react/components/shared/ModalsV2/FullScreenModal";
import { classNames } from "@/react/helpers/twMergeWithCN";

export type TabContainerVariants = "traditional" | "full-width";

interface TabContainerProps {
  className?: string;
  variants?: TabContainerVariants;
}

export const TabContainer = ({
  children,
  className,
  variants = "traditional",
}: PropsWithChildren<TabContainerProps>) => {
  const isTraditional = variants === "traditional";

  const WrapperClass = isTraditional ? FullScreenModal.Body : Fragment;

  return (
    <WrapperClass
      className="!h-[calc(100svh-12.75rem)] md:!h-[calc(100svh-11.75rem)] lg:!h-[calc(100svh-4.90rem)]"
      wrapperClassName="md:w-[45rem]"
    >
      <div
        className={classNames(
          "flex flex-col gap-y-8",
          {
            "px-5 py-6 md:w-[45rem] md:px-0 md:py-12": isTraditional,
          },
          className,
        )}
      >
        {children}
      </div>
    </WrapperClass>
  );
};
